import {Injectable, PipeTransform, Pipe} from '@angular/core';

@Pipe({
  name: 'positiveValue'
})

@Injectable()
export class PositiveValue implements PipeTransform {
  transform(num: number): number {
    return Math.abs(num);
  }
}
